import { render, staticRenderFns } from "./biaozhu-detail.vue?vue&type=template&id=49e19339&"
import script from "./biaozhu-detail.vue?vue&type=script&lang=ts&"
export * from "./biaozhu-detail.vue?vue&type=script&lang=ts&"
import style0 from "./biaozhu-detail.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports